export default __webpack_public_path__ + "static/media/award3.b8148fed.svg";